import { render, staticRenderFns } from "./OfferLinkPopup.vue?vue&type=template&id=20c59949&scoped=true&"
import script from "./OfferLinkPopup.vue?vue&type=script&lang=ts&"
export * from "./OfferLinkPopup.vue?vue&type=script&lang=ts&"
import style0 from "./OfferLinkPopup.vue?vue&type=style&index=0&id=20c59949&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c59949",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20c59949')) {
      api.createRecord('20c59949', component.options)
    } else {
      api.reload('20c59949', component.options)
    }
    module.hot.accept("./OfferLinkPopup.vue?vue&type=template&id=20c59949&scoped=true&", function () {
      api.rerender('20c59949', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/OfferLinkPopup.vue"
export default component.exports